import React from 'react'
import { ReactComponent as ArrowRolloverLogoRightSvg} from '../../assets/svgs/arrows/Arrow_Rollover_Logo_Right.svg';

const ArrowRolloverLogoRightIcon = () => (
    <div>
        <ArrowRolloverLogoRightSvg/>
    </div>
)

export default ArrowRolloverLogoRightIcon